export const imageMap = {
    "cuff-canting": require('./categories/cuffs.jpg'),
    "under-sole-canting": require('./categories/under-sole-canting.jpg'),
    "tools": require('./categories/tools.jpg'),
    "binding-specific": require('./categories/binding.jpg'),
}